import { Edit, SimpleForm, TextInput } from "react-admin";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import { Grid } from "@mui/material";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditUsers = () => {
  return (
    <Edit
      title="Редакция на профил"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextInput
              label="Име"
              source="firstName"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextInput
              label="Презиме"
              source="secondName"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextInput
              label="Фамилия"
              source="lastName"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextInput
              label="ЕГН"
              source="personId"
            />
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <TextInput
              label="Тел. номер"
              source="contactPhone"
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
export default EditUsers;
